import { defineModule } from '../utils/helpers';

// The first match wins, so mark exactly one element. A project with a desktop
// and a mobile header measures whichever comes first in the document, not
// whichever is visible.
const getHeader = () =>
  document.querySelector<HTMLElement>('[data-sticky-header]');

let observer: ResizeObserver | null = null;

// Exported because `vendor/swup.ts` re-measures mid-visit, before the module
// lifecycle runs again.
export const publishStickyHeaderHeight = () => {
  const header = getHeader();

  if (!header) {
    document.documentElement.style.removeProperty('--sticky-header-height');

    return;
  }

  document.documentElement.style.setProperty(
    '--sticky-header-height',
    `${header.offsetHeight}px`,
  );
};

export default defineModule(
  () => {
    publishStickyHeaderHeight();

    const header = getHeader();

    if (!header) return;

    // A setup that runs without its cleanup leaves the previous one observing.
    observer?.disconnect();
    observer = new ResizeObserver(publishStickyHeaderHeight);
    observer.observe(header);
  },
  () => {
    observer?.disconnect();
    observer = null;
  },
);
